import React, { useState } from "react";
import { Row, Col, Card, Form, Input, Spin, PageHeader, Alert } from "antd";
import { useSelector } from "react-redux";
import { CustomBtn } from "../../../components/Button";
import {
  useBillFaarfGetMutation,
  useBillFaarfPayMutation,
  useBillFeesMutation,
} from "../service/bill-api";
import TransactionResume from "../../../components/Dialog/transaction-resume";
import SuccessDialog from "../../../components/Dialog/success";

export function BillFaarfPage() {
  const { currentAgent } = useSelector((state) => state.auth);
  const [billFaarfGet] = useBillFaarfGetMutation();
  const [billFees] = useBillFeesMutation();
  const [billFaarfPay] = useBillFaarfPayMutation();
  const [show, setShow] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [isCustomer, setIsCustomer] = useState(false);
  const [fees, setFees] = useState();
  const [formdata, setFormData] = useState();
  const [form] = Form.useForm();

  const handleSearch = async (value) => {
    setIsLoading(true);
    const data = {
      agent_msisdn: currentAgent.phone,
      numero_pret: value.numero_pret,
      country: currentAgent.country,
      token: currentAgent.access_token,
      pincode: "",
    };
    billFaarfGet(data)
      .unwrap()
      .then((res) => {
        setIsLoading(false);
        setError();
        setIsCustomer(true);
        form.setFieldsValue({
          nom_client: res.data.nom_client,
          nom_gerant: res.data.nom_gerant,
          numero_client: res.data.numero_client,
          numero_gerant: res.data.numero_gerant,
        });
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error.data.error);
      });
  };

  const handleFees = async (value) => {
    setIsLoading(true);
    const data = {
      country: currentAgent.country,
      montant: value.montant,
      operation: "COLLECTE",
      pincode: "",
      receiver: "33036",
      token: currentAgent.access_token,
    };
    setFormData(value);
    billFees(data)
      .unwrap()
      .then((res) => {
        setIsLoading(false);
        setError();
        setFees(res);
        setShow(true);
        console.log("res.data:", res);
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error.data.error);
      });
  };

  const handlePay = async (pin) => {
    setIsLoading(true);
    setShow(false);
    const data = {
      pincode: pin,
      numero_pret: formdata.numero_pret,
      nom_client: formdata.nom_client,
      numero_client: formdata.numero_client,
      nom_gerant: formdata.nom_gerant,
      numero_gerant: formdata.numero_gerant,
      montant: formdata.montant,
      country: currentAgent.country,
      pin: pin,
      token: currentAgent.access_token,
    };
    billFaarfPay(data)
      .unwrap()
      .then((res) => {
        setIsSuccess(true);
        setIsLoading(false);
        setIsCustomer(false);
        form.resetFields();
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error.data.error);
      });
  };

  return (
    <div className="default-page">
      <TransactionResume
        title="Payement Faarf"
        message={
          "Vous allez effectuer un payement FAARF d'un montant de " +
          fees?.amount +
          " F CFA"
        }
        fees={fees?.fees}
        status={show}
        handleCancel={() => setShow(false)}
        handlePay={handlePay}
      />
      <SuccessDialog
        message="Transaction effectuée avec succès"
        status={isSuccess}
        handleCancel={() => setIsSuccess(false)}
      />
      <PageHeader title="Payement FAARF" />
      <Spin tip="Chargement..." spinning={isLoading}>
        <Row gutter={16}>
          <Col lg={12} xs={24}>
            <Card>
              <Form
                name="basic"
                form={form}
                layout="vertical"
                // initialValues={{ numero_pret: "1100867032" }}
                onFinish={isCustomer ? handleFees : handleSearch}
              >
                <Form.Item label="Numéro de prêt" name="numero_pret">
                  <Input className="form-control" placeholder="Nom du client" />
                </Form.Item>

                {isCustomer && (
                  <div>
                    <Form.Item label="Nom du client" name="nom_client">
                      <Input
                        className="form-control"
                        placeholder="Nom du client"
                        disabled
                      />
                    </Form.Item>

                    <Form.Item label="Nom du gerant" name="nom_gerant">
                      <Input
                        className="form-control"
                        placeholder="Nom du gerant"
                        disabled
                      />
                    </Form.Item>

                    <Form.Item label="Numéro du gérant" name="numero_gerant">
                      <Input
                        className="form-control"
                        placeholder="Numéro du gérant"
                        disabled
                      />
                    </Form.Item>

                    <Form.Item
                      label="Numéro du Client"
                      name="numero_client"
                      style={{ display: "none" }}
                    >
                      <Input
                        className="form-control"
                        placeholder="Numéro du Client"
                        disabled
                      />
                    </Form.Item>

                    <Form.Item
                      label="Montant"
                      name="montant"
                      rules={[
                        {
                          required: true,
                          message: "Veuillez saisir un numéro",
                        },
                      ]}
                    >
                      <Input className="form-control" placeholder="Montant" />
                    </Form.Item>
                  </div>
                )}

                {error && (
                  <Form.Item>
                    <Alert message={error} type="error" showIcon />
                  </Form.Item>
                )}
                <Form.Item>
                  <CustomBtn title={isCustomer ? "Valider" : "Rechercher"} />
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </Spin>
    </div>
  );
}
export default BillFaarfPage;
